import API from 'services/api';

export const getBanks = (): Promise<{ value: number; label: string }[]> =>
  API.get('api/root/banks/all').then(response => response?.data);
